import {
	PopOverState,
	SHOW_POP_OVER,
	HIDE_POP_OVER,
	SET_BANNER_HAS_BEEN_SHOWN,
	SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN,
	SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN,
	BUILD_TIP_HAS_BEEN_SHOWN,
	HIDE_BUILD_TIP,
} from './types';
import { SET_ORIENTATION } from '../deviceInfo/types';
import { Actions } from '..';

const initialState: PopOverState = {
	bannerHasBeenShown: false,
	placementInformationHasBeenShown: false,
	missingCoverSectionHasBeenShown: false,
	buildTipHasBeenShown: false,
	hideBuildTip: false,
	disabledDrag: {
		type: 'disabled-drag',
		showPopOver: false,
	},
	middleModuleDrag: {
		type: 'middle-module-drag',
		showPopOver: false,
	},
	invalidPlacement: {
		type: 'invalid-placement',
		showPopOver: false,
	},
	placementInformation: {
		type: 'placement-information',
		showPopOver: false,
	},
	noValidConnection: {
		type: 'no-valid-connection',
		showPopOver: false,
	},
	buildLimit: {
		type: 'build-limit',
		showPopOver: false,
	},
	unfinishedSection: {
		type: 'unfinished-section',
		showPopOver: false,
	},
	missingCoverSection: {
		type: 'missing-cover-section',
		showPopOver: false,
	},
};

export function popOverReducer(state = initialState, action: Actions): PopOverState {
	switch (action.type) {
		case SHOW_POP_OVER: {
			switch (action.value.type) {
				case 'disabled-drag':
					return {
						...state,
						disabledDrag: {
							type: action.value.type,
							top: action.value.top,
							left: action.value.left,
							showPopOver: true,
						},
					};
				case 'build-limit':
					return { ...state, buildLimit: { type: action.value.type, showPopOver: true } };
				case 'middle-module-drag':
					return {
						...state,
						middleModuleDrag: {
							type: action.value.type,
							top: action.value.top,
							left: action.value.left,
							showPopOver: true,
						},
					};
				case 'invalid-placement':
					return {
						...state,
						invalidPlacement: {
							type: action.value.type,
							top: action.value.top,
							left: action.value.left,
							showPopOver: true,
							translationKey: action.value.translationKey,
						},
					};
				case 'placement-information':
					if (!state.placementInformationHasBeenShown) {
						return {
							...state,
							placementInformation: {
								type: action.value.type,
								top: action.value.top,
								left: action.value.left,
								showPopOver: true,
								translationKey: action.value.translationKey,
							},
						};
					} else {
						return state;
					}
				case 'no-valid-connection':
					return {
						...state,
						noValidConnection: {
							type: action.value.type,
							top: action.value.top,
							left: action.value.left,
							showPopOver: true,
						},
					};
				case 'unfinished-section':
					return {
						...state,
						unfinishedSection: {
							type: action.value.type,
							top: action.value.top,
							left: action.value.left,
							showPopOver: true,
						},
					};
				case 'missing-cover-section':
					if (!state.missingCoverSectionHasBeenShown) {
						return {
							...state,
							missingCoverSectionHasBeenShown: true,
							missingCoverSection: {
								type: action.value.type,
								top: action.value.top,
								left: action.value.left,
								showPopOver: true,
							},
						};
					} else {
						return state;
					}
			}
		}
		case HIDE_POP_OVER: {
			switch (action.value.type) {
				case 'disabled-drag':
					return { ...state, disabledDrag: { type: action.value.type, showPopOver: false } };
				case 'build-limit':
					return { ...state, buildLimit: { type: action.value.type, showPopOver: false } };
				case 'middle-module-drag':
					return { ...state, middleModuleDrag: { type: action.value.type, showPopOver: false } };
				case 'invalid-placement':
					return {
						...state,
						invalidPlacement: { type: action.value.type, showPopOver: false },
					};
				case 'no-valid-connection':
					return {
						...state,
						noValidConnection: { type: action.value.type, showPopOver: false },
					};
				case 'placement-information':
					if (state.placementInformation.showPopOver) {
						return {
							...state,
							placementInformation: { type: action.value.type, showPopOver: false },
							placementInformationHasBeenShown: true,
						};
					} else {
						return { ...state };
					}
				case 'unfinished-section':
					return { ...state, unfinishedSection: { type: action.value.type, showPopOver: false } };
				case 'missing-cover-section':
					return { ...state, missingCoverSection: { type: action.value.type, showPopOver: false } };
				case 'all':
					return {
						...state,
						disabledDrag: { type: 'disabled-drag', showPopOver: false },
						buildLimit: { type: 'build-limit', showPopOver: false },
						middleModuleDrag: { type: 'middle-module-drag', showPopOver: false },
						invalidPlacement: { type: 'invalid-placement', showPopOver: false },
						noValidConnection: { type: 'no-valid-connection', showPopOver: false },
						unfinishedSection: { type: 'unfinished-section', showPopOver: false },
						missingCoverSection: { type: 'missing-cover-section', showPopOver: false },
					};
				default:
					return {
						...state,
						disabledDrag: { type: action.value.type, showPopOver: false },
						buildLimit: { type: action.value.type, showPopOver: false },
						middleModuleDrag: { type: action.value.type, showPopOver: false },
						unfinishedSection: { type: action.value.type, showPopOver: false },
						missingCoverSection: { type: action.value.type, showPopOver: false },
					};
			}
		}
		case SET_ORIENTATION: {
			return {
				...state,
				disabledDrag: { type: 'disabled-drag', showPopOver: false },
				buildLimit: { type: 'build-limit', showPopOver: false },
				middleModuleDrag: { type: 'middle-module-drag', showPopOver: false },
				invalidPlacement: { type: 'invalid-placement', showPopOver: false },
				noValidConnection: { type: 'no-valid-connection', showPopOver: false },
				unfinishedSection: { type: 'unfinished-section', showPopOver: false },
				missingCoverSection: { type: 'missing-cover-section', showPopOver: false },
			};
		}
		case SET_BANNER_HAS_BEEN_SHOWN: {
			return { ...state, bannerHasBeenShown: action.value };
		}
		case SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN: {
			return { ...state, placementInformationHasBeenShown: action.value };
		}
		case SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN: {
			return { ...state, missingCoverSectionHasBeenShown: action.value };
		}
		case BUILD_TIP_HAS_BEEN_SHOWN:
			return { ...state, buildTipHasBeenShown: action.value };
		case HIDE_BUILD_TIP:
			return { ...state, hideBuildTip: action.value };
		default:
			return state;
	}
}
